'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_sc_MapFactory$ToFactory(factory) {
  this.MJ = null;
  this.MJ = factory;
}
export { $c_sc_MapFactory$ToFactory as $c_sc_MapFactory$ToFactory };
$p = $c_sc_MapFactory$ToFactory.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_sc_MapFactory$ToFactory;
/** @constructor */
function $h_sc_MapFactory$ToFactory() {
}
export { $h_sc_MapFactory$ToFactory as $h_sc_MapFactory$ToFactory };
$h_sc_MapFactory$ToFactory.prototype = $p;
$p.A = (function(it) {
  return this.MJ.aH(it);
});
var $d_sc_MapFactory$ToFactory = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sc_MapFactory$ToFactory, "scala.collection.MapFactory$ToFactory", ({
  st: 1,
  eX: 1,
  a: 1
}));
export { $d_sc_MapFactory$ToFactory as $d_sc_MapFactory$ToFactory };
